import React from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import {
  cacheEmotion as cacheEmotionLego,
  CacheProvider as CacheProviderLego,
  legoThemes,
  ThemeProvider,
} from "@ugc-ui/lego";
import { stores, StoresContext } from "@client/store";
import { Notice } from "@common/components/Notice/Notice";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "@client/routes";
import { useVhBody } from "@common/hooks/useVhBody";

const cacheEmotion = createCache({
  key: "rk",
});

export const App = (): JSX.Element => {
  useVhBody();

  return (
    <StoresContext.Provider value={stores}>
      <CacheProviderLego value={cacheEmotionLego}>
        <CacheProvider value={cacheEmotion}>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <ThemeProvider theme={legoThemes.dark}>
            <Notice />
            <Router>
              <Routes />
            </Router>
          </ThemeProvider>
        </CacheProvider>
      </CacheProviderLego>
    </StoresContext.Provider>
  );
};
